/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageSubmissionsSummary } from '../../models/page-submissions-summary';
import { SubmissionsStatusFilterEnum } from '../../models/submissions-status-filter-enum';

export interface GetSubmissionsSummaryBySubmissionsCycleApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet$Params {
  id: string;
  org: string;
  supplierName?: (string | null);
  status?: (Array<SubmissionsStatusFilterEnum> | null);
  sortStatus?: ('asc' | 'desc' | null);

/**
 * Page number
 */
  page?: number;

/**
 * Page size
 */
  size?: number;
}

export function getSubmissionsSummaryBySubmissionsCycleApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet(http: HttpClient, rootUrl: string, params: GetSubmissionsSummaryBySubmissionsCycleApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PageSubmissionsSummary>> {
  const rb = new RequestBuilder(rootUrl, getSubmissionsSummaryBySubmissionsCycleApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('org', params.org, {});
    rb.query('supplierName', params.supplierName, {});
    rb.query('status', params.status, {});
    rb.query('sortStatus', params.sortStatus, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageSubmissionsSummary>;
    })
  );
}

getSubmissionsSummaryBySubmissionsCycleApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet.PATH = '/api/v2/submissions/{org}/submissions-cycle/{id}/submissions/summary';
